import { FuseNavigationItem } from '@fuse/components/navigation';
import { Navigation } from './navigation.types';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'landing',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/landing',
    },
    {
        id: 'inventory',
        title: 'Inventory',
        type: 'basic',
        icon: 'spf:inventory',
        link: '/inventory',
    },
    {
        id: 'vehicles',
        title: 'Models',
        type: 'basic',
        icon: 'spf:models',
        link: '/vehicles',
    },
    {
        id: 'license',
        title: 'Licensing',
        type: 'basic',
        icon: 'heroicons_outline:document-check',
        link: '/license',
    },
    {
        id: 'news',
        title: 'News',
        type: 'basic',
        icon: 'heroicons_outline:newspaper',
        link: '/news',
    },
    {
        id: 'events',
        title: 'Events',
        type: 'basic',
        icon: 'heroicons_outline:calendar-days',
        link: '/events',
    },
    {
        id: 'about-group',
        title: 'About Us',
        type: 'collapsable',
        icon: 'heroicons_outline:information-circle',
        children: [
            {
                id: 'company',
                title: 'Company',
                type: 'basic',
                link: '/about',
            },
            {
                id: 'factory',
                title: 'Factory',
                type: 'basic',
                link: '/factory',
            },
            {
                id: 'gallery',
                title: 'Gallery',
                type: 'basic',
                link: '/gallery',
            },
            {
                id: 'testimonials',
                title: 'Testimonials',
                type: 'basic',
                link: '/testimonials',
            },
        ],
    },
    {
        id: 'dealers',
        title: 'Dealers',
        type: 'basic',
        icon: 'heroicons_outline:briefcase',
        link: '/dealers',
    },
    {
        id: 'faq',
        title: "FAQ'S",
        type: 'basic',
        icon: 'heroicons_outline:question-mark-circle',
        link: '/faq',
    },
    {
        id: 'contact',
        title: 'Contact',
        type: 'basic',
        icon: 'heroicons_outline:envelope',
        link: '/contact',
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];

export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];

export const horizontalNavigation: FuseNavigationItem[] = [
    { id: 'inventory', title: 'Inventory', type: 'basic', link: '/inventory' },
    { id: 'vehicles', title: 'Models', type: 'basic', link: '/vehicles' },
    { id: 'license', title: 'Licensing', type: 'basic', link: '/license' },
    { id: 'news', title: 'News', type: 'basic', link: '/news' },
    { id: 'events', title: 'Events', type: 'basic', link: '/events' },
    {
        id: 'about-group',
        title: 'About Us',
        type: 'collapsable',
        children: [
            { id: 'company', title: 'Company', type: 'basic', link: '/about' },
            { id: 'factory', title: 'Factory', type: 'basic', link: '/factory' },
            { id: 'gallery', title: 'Gallery', type: 'basic', link: '/gallery' },
            {
                id: 'testimonials',
                title: 'Testimonials',
                type: 'basic',
                link: '/testimonials',
            },
        ],
    },
];

export function cloneNavigationItems(
    items: FuseNavigationItem[] = []
): FuseNavigationItem[] {
    return items.map((item) => ({
        ...item,
        children: item.children ? cloneNavigationItems(item.children) : undefined,
    }));
}

export function cloneNavigation(): Navigation {
    return {
        compact: cloneNavigationItems(compactNavigation),
        default: cloneNavigationItems(defaultNavigation),
        futuristic: cloneNavigationItems(futuristicNavigation),
        horizontal: cloneNavigationItems(horizontalNavigation),
    };
}
